<template>
    <div>
        <div slot="header" class="clearfix">
            <span>{{title}}</span>
        </div>

        <div :id="id" :style="{height: '400px', width: '1100px'}"></div>

    </div>
</template>

<script>
    import * as echarts from 'echarts';
    export default {
        name: "component_echart",
        data () {
            return {
                chartData: null,
            }
        },
        props: ['option','id','title','content','width', 'height', 'isRefresh'],
        mounted() {
          this.show();
        },
        watch: {
            isRefresh(n,l) {
                if (this.isRefresh) {
                    this.show();
                } else {
                    this.show();
                }
            }
        },
        methods: {
            show() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.chartData = echarts.getInstanceByDom(document.getElementById(this.id));

                        if (this.chartData == null) {
                            this.chartData = echarts.init(document.getElementById(this.id));
                        }
                        // this.chartData = echarts.init(document.getElementById(this.id));
                        this.chartData.setOption(this.option);

                        window.addEventListener("resize", this.handle);
                    },3000)
                })
            },

            handle() {
                this.chartData.resize();
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/component_echart.vue